<template>
<div id="agentes" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Agentes Aduanales" class="elevation-1 px-5 py-3" >

                    <v-tabs grow style="margin-bottom: 30px;" >
                        <v-tabs-slider color="primary" ></v-tabs-slider>

                        <v-tab key="consulta" >
                            <v-card-title><b>Agentes Aduanales</b></v-card-title>
                        </v-tab>
                       <v-tab key="sat" v-if="false" >
                            <v-card-title><b>Patentes Exclusivas por RFC - VUCEM</b></v-card-title>
                        </v-tab> 
                        <v-tab key="reporte_patentes" >
                            <v-card-title><b>Reporte de Agentes Aduanales</b></v-card-title>
                        </v-tab> 
                        <v-tab-item key="consulta" style="margin: 30px;" >

                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-speed-dial direction="left" open-on-hover>
                                    <template v-slot:activator>
                                        <v-btn x-small fab dark color="primary" >
                                            <v-icon>reorder</v-icon>
                                        </v-btn>
                                    </template>

                                    <!-- Exportar Domicilios y Contactos-->
                                    <exportar-excel :data="items_contactos" :exportFields="agentes.camposexcelcontactos" name="Contactos Agentes.xlsx" >
                                        <v-btn fab dark x-small color="green darken-4" title="Exportar Contactos" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>

                                    <exportar-excel :data="items_domicilios" :exportFields="agentes.camposexceldomicilios" name="Domicilios Agentes.xlsx" >
                                        <v-btn fab dark x-small color="green darken-2" title="Exportar Domicilios" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    <!-- Exportar Domicilios y Contactos-->

                                    <exportar-excel :data="datafiltered" :exportFields="agentes.camposexcel" name="Agentes.xlsx" >
                                        <v-btn fab dark x-small color="success" title="Exportar Registros" v-tippy>
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                                    <exportar-excel :data="agentes.camposLayout" :exportFields="agentes.encabezadoLayout" name="Layout Agentes Aduanales.xlsx" >
                                        <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </v-speed-dial>

                                <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                                    <v-icon dark>add</v-icon>
                                </v-btn>

                                <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                                    <v-card>
                                        <v-card-title>
                                            <v-card class="primary white--text titulomodal" >
                                                <v-icon class="white--text" >
                                                    {{
                        update ? "edit" : "add"
                        }}
                                                </v-icon>&nbsp;
                                                <span class="subheading" >
                                                    <strong>
                                                        {{ update ? "Actualizar" : "Nuevo" }} Agente
                                                        Aduanal
                                                    </strong>
                                                </span>
                                            </v-card>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click.native="modal = false" class="close_modal" >
                                                <v-icon class="white--text" >cancel</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-form ref="form" lazy-validation>
                                            <v-card-text>
                                                <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                                    <v-row v-if="rfc_agencia!=''">
                                                        <v-col sm="12" md="10" lg="10">
                                                        <v-autocomplete :hide-no-data="true" :items="clientes_agencia"
                                                            v-model="model.cliente" :rules="[rules.required]" :item-text="getNombreCliente"
                                                            item-value="id_cliente"
                                                            label="Seleccione RFC de Cliente"></v-autocomplete>
                                                        </v-col>
                                                    </v-row>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field name="nombre" label="Nombre" type="text" v-model="model.nombre" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field name="rfc" label="RFC o TAX ID" type="text" @input="model.rfc = model.rfc.toUpperCase()" v-model="model.rfc" :rules="[rules.required, rules.rfclen]" maxlength="20" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field name="patente" label="Patente" type="text" v-model="model.patente" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field name="aduanas_operacion" label="RFC Sociedad" type="text" v-model="model.aduanas_operacion" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field name="telefono" label="Teléfono" type="text" v-model="model.telefono" maxlength="50" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field name="agencia_aduanal" label="Agencia Aduanal" type="text" v-model="model.agencia_aduanal" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="Calle" type="text" v-model="model.calle" maxlength="150" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="No. Exterior" type="text" v-model="model.numero_exterior" maxlength="10" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="No. Interior" type="text" v-model="model.numero_interior" maxlength="10" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field label="Colonia" type="text" v-model="model.colonia" maxlength="100" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field label="Código Postal" type="text" v-model="model.codigo_postal" maxlength="10" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12>
                                                            <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                                                            <v-combo-paises :option_required="0" :option_combos="1" :param_pais="model.pais" :on-select-pais="selectComboPais" />
                                                        </v-flex>
                                                        <v-flex s12>
                                                            <v-text-field label="Estado" type="text" v-model="model.estado_nombre" maxlength="150" ></v-text-field>                                                    
                                                        </v-flex>
                                                        <v-flex s12>
                                                            <v-text-field label="Ciudad" type="text" v-model="model.ciudad" maxlength="50" ></v-text-field>                                                    
                                                        </v-flex>
                                                        <v-flex s12>
                                                            <v-text-field label="Municipio" type="text" v-model="model.municipio" maxlength="50" ></v-text-field>                                                    
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="Banco" type="text" v-model="model.banco" maxlength="150" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="Sucursal" type="text" v-model="model.sucursal" maxlength="50" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="No. Cuenta" type="text" v-model="model.cuenta" maxlength="50" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="CLABE" type="text" v-model="model.clabe" maxlength="25" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="SWIFT" type="text" v-model="model.swift" maxlength="50" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="ABA" type="text" v-model="model.aba" maxlength="50" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="Banco Interamericano" type="text" v-model="model.banco_interamericano" maxlength="150" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="Beneficiario" type="text" v-model="model.beneficiario" maxlength="150" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="Referencia Banco" type="text" v-model="model.referencia_banco" maxlength="150" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field name="metadato" label="Metadato" type="text" v-model="model.metadato" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-text>
                                        </v-form>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click.native="modal = false" >
                                                <v-icon>cancel</v-icon>Cancelar
                                            </v-btn>
                                            <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                                <v-icon>done</v-icon>
                                                {{ update ? "Actualizar" : "Guardar" }}
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>

                                <!--MODAL DOMICLIO-->
                                <v-dialog v-model="modalDomicilio" max-width="60%" style=" z-index: 400 !important;" >
                                    <v-card>
                                        <v-card-title>
                                            <v-card class="primary white--text titulomodal" >
                                                <v-icon class="white--text" >address-card</v-icon>&nbsp;
                                                <span class="subheading" >
                                                    <strong>Otros Domicilios {{' del agente: '+agente_seleccionado_metadato}}</strong>
                                                </span>
                                            </v-card>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click.native="modalDomicilio = false" class="close_modal" >
                                                <v-icon class="white--text" >cancel</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-form ref="formDomicilio" lazy-validation>
                                            <v-card-text>
                                                <v-container grid-list-md text-xs-center @keyup.enter="guardarDomicilio()" >
                                                    <v-layout row wrap>
                                                        <v-flex s12 m3 l3>
                                                            <v-text-field label="Calle" type="text" v-model="modelDomicilio.calle" maxlength="150" :rules="[rules.required]" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m3 l3>
                                                            <v-text-field label="No. Exterior" type="text" v-model="modelDomicilio.numero_exterior" maxlength="10" :rules="[rules.required]" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m3 l3>
                                                            <v-text-field label="No. Interior" type="text" v-model="modelDomicilio.numero_interior" maxlength="10" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m3 l3></v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m6 l6>
                                                            <v-text-field label="Colonia" type="text" v-model="modelDomicilio.colonia" maxlength="100" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m16 l6>
                                                            <v-text-field label="Código Postal" type="text" v-model="modelDomicilio.codigo_postal" maxlength="10" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12>
                                                            <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                                                            <v-combo-paises :option_required="0" :option_combos="1" :param_pais="modelDomicilio.pais" :on-select-pais="selectComboPaisDomicilio" />
                                                        </v-flex>
                                                        <v-flex s12>
                                                            <v-text-field label="Estado" type="text" v-model="modelDomicilio.estado_nombre" maxlength="150" ></v-text-field>                                                    
                                                        </v-flex>
                                                        <v-flex s12>
                                                            <v-text-field label="Ciudad" type="text" v-model="modelDomicilio.ciudad" maxlength="50" ></v-text-field>                                                    
                                                        </v-flex>
                                                        <v-flex s12>
                                                            <v-text-field label="Municipio" type="text" v-model="modelDomicilio.municipio" maxlength="50" ></v-text-field>                                                    
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m4 l4>
                                                            <v-autocomplete v-model="modelDomicilio.aduana" :items="aduanas" :hide-no-data="true" :hide-selected="true" :item-text="nombreAduanaSelect" item-value="id_aduana" label="Selecciona una Aduana" :rules="[rules.required, uniqueAduanaDomicilio(modelDomicilio)]" ></v-autocomplete>
                                                        </v-flex>
                                                        <v-flex s12 m4 l4>
                                                            <v-text-field label="Notas" type="text" v-model="modelDomicilio.notas" maxlength="255" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-text>
                                        </v-form>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click.native="modalDomicilio = false" >
                                                <v-icon>cancel</v-icon>Cancelar
                                            </v-btn>
                                            <v-btn color="success" :loading="loading" @click.native="guardarDomicilio()" >
                                                <v-icon>done</v-icon>Guardar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>

                                <!--MODAL CONTACTO-->
                                <v-dialog v-model="modalContacto" max-width="60%" style=" z-index: 400 !important;" >
                                    <v-card>
                                        <v-card-title>
                                            <v-card class="primary white--text titulomodal" >
                                                <v-icon class="white--text" >address-book</v-icon>&nbsp;
                                                <span class="subheading" >
                                                    <strong>Información de Contactos {{' del agente: '+agente_seleccionado_metadato}}</strong>
                                                </span>
                                            </v-card>
                                            <v-spacer></v-spacer>
                                            <v-btn icon @click.native="modalContacto = false" class="close_modal" >
                                                <v-icon class="white--text" >cancel</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-form ref="formContacto" lazy-validation>
                                            <v-card-text>
                                                <v-container grid-list-md text-xs-center @keyup.enter="guardarContacto()" >
                                                    <v-layout row wrap>
                                                        <v-flex s12 m3 l3>
                                                            <v-autocomplete v-model="modelContacto.aduana" :items="aduanas" :hide-no-data="true" :hide-selected="true" :item-text="nombreAduanaSelect" item-value="id_aduana" label="Selecciona una Aduana" :rules="[rules.required, uniqueAduanaContacto(modelContacto)]" ></v-autocomplete>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex s12 m3 l3>
                                                            <v-text-field label="Nombre Contacto" type="text" v-model="modelContacto.nombre" maxlength="150" :rules="[rules.required]" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m3 l3>
                                                            <v-text-field label="Email" type="text" v-model="modelContacto.email" maxlength="150" :rules="[rules.required, rules.email]" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m3 l3>
                                                            <v-text-field label="Teléfono" type="text" v-model="modelContacto.telefono" maxlength="50" ></v-text-field>
                                                        </v-flex>
                                                        <v-flex s12 m3 l3>
                                                            <v-text-field label="Móvil" type="text" v-model="modelContacto.movil" maxlength="50" ></v-text-field>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-text>
                                        </v-form>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click.native="modalContacto = false" >
                                                <v-icon>cancel</v-icon>Cancelar
                                            </v-btn>
                                            <v-btn color="success" :loading="loading" @click.native="guardarContacto()" >
                                                <v-icon>done</v-icon>Guardar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-card-actions>

                            <v-card-text>
                                <div id="datagrid" >
                                    <v-client-table ref="principalTable" :data="agentes.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <template slot="detail" slot-scope="props" >
                                            <v-btn text icon color="primary" title="Mostrar Domicilios" @click="showDetail(props.row)" >
                                                <v-icon v-if="agente_seleccionado != props.row.id_agente_aduanual" >add_circle</v-icon>
                                                <v-icon v-if="agente_seleccionado == props.row.id_agente_aduanual" >remove_circle</v-icon>
                                            </v-btn>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                                <template v-slot:activator>
                                                    <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                        <v-icon>reorder</v-icon>
                                                    </v-btn>
                                                </template>

                                                <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_agente_aduanual)
                        " title="Editar Registro" v-tippy>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                                <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_agente_aduanual)
                        " title="Eliminar Registro" v-tippy>
                                                    <v-icon>delete</v-icon>
                                                </v-btn>
                                            </v-speed-dial>
                                        </template>

                                        <template slot="child_row" >
                                            <v-app-bar dense height="35pt" >

                                                <span style="font-size:12pt" >Otros Domicilios {{agente_seleccionado == '' ? '[Seleccione un agente para ver sus domicilios]' : ' del agente: '+agente_seleccionado_metadato}}</span>

                                            </v-app-bar>
                                            <v-card-text>
                                                <div class="row" >
                                                    <div class="col-xs-1" >
                                                        <v-btn v-if="agente_seleccionado!=''" fab dark small color="green" @click="openModalOtro('domicilio',1)" title="Agregar Domicilio" v-tippy>
                                                            <v-icon dark>add</v-icon>
                                                        </v-btn>
                                                    </div>
                                                </div>
                                                <div class="row" >
                                                    <div class="col-xs-10" ></div>
                                                </div>
                                                <v-client-table ref="vuetable" :data="domicilios.items" :columns="columnsDomicilios" :options="optionsDomicilios" class="elevation-2 pa-2" >
                                                    <template slot="noResults" >
                                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                                    </template>

                                                    <template slot="actions" slot-scope="props" >
                                                        <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                                            <template v-slot:activator>
                                                                <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                                    <v-icon>reorder</v-icon>
                                                                </v-btn>
                                                            </template>

                                                            <v-btn icon small fab dark color="blue" @click.native="
                                    getRegistroDomicilio(props.row.id_domicilio_agente_aduanal)
                                  " title="Editar Registro" v-tippy>
                                                                <v-icon>edit</v-icon>
                                                            </v-btn>
                                                            <v-btn icon small fab dark color="pink" @click.native="
                                    deleteRegistroDomicilio(props.row.id_domicilio_agente_aduanal)
                                  " title="Eliminar Registro" v-tippy>
                                                                <v-icon>delete</v-icon>
                                                            </v-btn>
                                                        </v-speed-dial>
                                                    </template>
                                                </v-client-table>
                                            </v-card-text>
                                            <hr />
                                            <v-app-bar dense height="35pt" >
                                                <span style="font-size:12pt" >Información de Contactos {{agente_seleccionado == '' ? '[Seleccione un agente para ver sus contactos]' : ' del agente: '+agente_seleccionado_metadato}}</span>
                                            </v-app-bar>
                                            <v-card-text>
                                                <div class="row" >
                                                    <div class="col-xs-1" >
                                                        <v-btn v-if="agente_seleccionado!=''" fab dark small color="green" @click="openModalOtro('contacto',1)" title="Agregar Contacto" v-tippy>
                                                            <v-icon dark>add</v-icon>
                                                        </v-btn>
                                                    </div>
                                                </div>
                                                <div class="row" >
                                                    <div class="col-xs-10" ></div>
                                                </div>
                                                <v-client-table ref="vuetable" :data="contactos.items" :columns="columnsContactos" :options="optionsContactos" class="elevation-2 pa-2" >
                                                    <template slot="noResults" >
                                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                                    </template>

                                                    <template slot="actions" slot-scope="props" >
                                                        <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                                            <template v-slot:activator>
                                                                <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                                    <v-icon>reorder</v-icon>
                                                                </v-btn>
                                                            </template>

                                                            <v-btn icon small fab dark color="blue" @click.native="
                                    getRegistroContacto(props.row.id_contacto_agente_aduanal)
                                  " title="Editar Registro" v-tippy>
                                                                <v-icon>edit</v-icon>
                                                            </v-btn>
                                                            <v-btn icon small fab dark color="pink" @click.native="
                                    deleteRegistroContacto(props.row.id_contacto_agente_aduanal)
                                  " title="Eliminar Registro" v-tippy>
                                                                <v-icon>delete</v-icon>
                                                            </v-btn>
                                                        </v-speed-dial>
                                                    </template>
                                                </v-client-table>
                                            </v-card-text>
                                        </template>
                                    </v-client-table>
                                </div>
                            </v-card-text>
                        </v-tab-item>
                        <v-tab-item key="sat" style="margin: 30px;" v-if="false" >
                           <v-alert border="top"
                                colored-border
                                type="error"
                                elevation="2"><p/>
                                    <center>
                                        <h1>Aviso</h1>
                                            <h3>
                                    Apreciables usuarios, hacemos de su conocimiento que el Sistema de Operación Integral Aduanero, 
                                    presenta problemas de desempeño por ajustes de servicio en la consulta remota.  </h3><p/>
                                    <h2>Agradecemos su comprensión.</h2>  <p/>
                                    <h3> Hemos reportado los errores presentados con el área correspondiente y estamos en monitoreo 
                                    de cambios para habilitar nuevamente el servicio de consulta
                                    </h3>
                                    </center>
                            </v-alert>
                            <v-card-text v-if="false">
                                <br />
                                <v-btn small @click="reload2" >
                                    <v-icon>mdi-cached</v-icon> Actualizar Contenido
                                </v-btn>
                                <p class="text--disabled caption font-weight-thin" >
                                    <v-icon color="indigo" >info</v-icon> Consulta de Situación de Patentes Exclusivas por RFC presenta algunas inconsistencias por si no carga la página vuelva actualizar nuevamente.
                                </p>
                                 <p class=" caption font-weight-thin text-center" >
                                     Copiar y pegar el RFC {{$local_storage.get("rfc")}}
                                     <v-btn color="secondary" x-small v-clipboard="$local_storage.get('rfc')" >
                                        <v-icon x-small>mdi-file</v-icon> Copiar
                                    </v-btn>
                                </p>
                                <div class="iframe-container" >
                                    <iframe id="myIframe2" src="https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_wfrPatConsulRFC.aspx" allowfullscreen></iframe>
                                </div>
                            </v-card-text>
                        </v-tab-item>
                        <v-tab-item key="reporte_patentes" style="margin: 30px;" >
                           
                            <repoagentes ref="repo-agentes" ></repoagentes>
                        </v-tab-item>
                    </v-tabs>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>


import axios from "axios";
import ComboPaises from "@/components/ComboPaises/index.vue";
import repoagentes from "@/views/catalogos/AgentesReporte.vue";

import {
    Promise
} from "q";

export default {
    components: {
        "v-combo-paises": ComboPaises, 
        repoagentes
    },

    data: () => ({
        clientes_agencia:[],
        rfc_agencia:"",
        fab: false,
        items_contactos: [],
        items_domicilios: [],
        name: "datagrid",
        importData: [],
        columns: [
            "detail",
            "rfc_cliente",
            "nombre",
            "rfc",
            "patente",
            "aduanas_operacion",
            "agencia_aduanal",
            "metadato",
            "actions"
        ],
        options: {
            filterable: [
                "rfc_cliente",
                "nombre",
                "rfc",
                "patente",
                "aduanas_operacion",
                "agencia_aduanal",
                "metadato"
            ],
            sortable: [
                "rfc_cliente",
                "nombre",
                "rfc",
                "patente",
                "aduanas_operacion",
                "agencia_aduanal",
                "metadato"
            ],

            headings: {
                rfc_cliente: "RFC Cliente",
                detail: "",
                nombre: "Nombre",
                rfc: "RFC o TAX ID",
                patente: "Patente",
                aduanas_operacion: "RFC Sociedad",
                agencia_aduanal: "Agencia Aduanal",
                metadato: "Metadato",
                actions: "Operaciones"
            },
            uniqueKey: "id_agente_aduanual"
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "Agentes Aduanales",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        modalDomicilio: false,
        modalContacto: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            id_agente_aduanual: 0,
            nombre: "",
            rfc: "",
            patente: "",
            aduanas_operacion: "",
            telefono: "",
            agencia_aduanal: "",
            cliente: 0,
            metadato: "N/A"
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
            rfclen: v =>
                (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres"
        },
        aduanas: [],
        paises: [],
        estados: [],
        ciudades: [],
        municipios: [],
        estados_todos: [], //para verificar que el ID de estado en los layout exista
        agentes: {
            selected: [],
            camposexcel: {
                "RFC Cliente": "rfc_cliente",
                Nombre: "nombre",
                RFC: "rfc",
                Patente: "patente",
                "RFC Sociedad": "aduanas_operacion",
                Teléfono: "telefono",
                "Agencia Aduanal": "agencia_aduanal",
                Metadato: "metadato",
                Calle: "calle",
                "No. Exterior": "numero_exterior",
                "No. Interior": "numero_interior",
                Colonia: "colonia",
                CP: "codigo_postal",
                Ciudad: "ciudad",
                Municipio: "municipio",
                Estado: "estado_nombre",
                Pais: "pais_nombre",
                Banco: "banco",
                Sucursal: "sucursal",
                Cuenta: "cuenta",
                Clabe: "clabe",
                Swift: "swift",
                Aba: "aba",
                "Banco Interamericano": "banco_interamericano",
                Beneficiario: "beneficiario",
                "Referencia Banco": "referencia_banco"
            },
            camposexcelcontactos: {
                Agente: "agente",
                Aduana: "aduana_nombre",
                "Nombre Contacto": "nombre",
                Email: "email",
                Telefono: "telefono",
                Móvil: "movil"
            },
            camposexceldomicilios: {
                Agente: "agente",
                Aduana: "aduana_nombre",
                Calle: "calle",
                "No. Exterior": "numero_exterior",
                "No. Interior": "numero_interior",
                Colonia: "colonia",
                CP: "codigo_postal",
                Ciudad: "ciudad",
                Municipio: "municipio",
                Estado: "estado_nombre",
                País: "pais_nombre",
                Notas: "notas"
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                //agente
                rfc_cliente: "rfc_cliente",
                nombre: "nombre",
                rfc: "rfc",
                patente: "patente",
                "rfc_sociedad": "rfc_sociedad",
                telefono: "telefono",
                agencia_aduanal: "agencia_aduanal",
                metadato: "metadato",
                calle: "calle",
                numero_exterior: "numero_exterior",
                numero_interior: "numero_interior",
                colonia: "colonia",
                codigo_postal: "codigo_postal",
                ciudad: "ciudad",
                municipio: "municipio",
                estado: "estado",
                pais: "pais",
                banco: "banco",
                sucursal: "sucursal",
                cuenta: "cuenta",
                clabe: "clabe",
                swift: "swift",
                aba: "aba",
                banco_interamericano: "banco_interamericano",
                beneficiario: "beneficiario",
                referencia_banco: "referencia_banco",
                //contactos
                aduana_contacto: "aduana_contacto",
                nombre_contacto: "nombre_contacto",
                email_contacto: "email_contacto",
                telefono_contacto: "telefono_contacto",
                movil_contacto: "movil_contacto",
                //domicilios
                aduana_domicilio: "aduana_domicilio",
                calle_domicilio: "calle_domicilio",
                numero_exterior_domicilio: "numero_exterior_domicilio",
                numero_interior_domicilio: "numero_interior_domicilio",
                colonia_domicilio: "colonia_domicilio",
                codigo_postal_domicilio: "codigo_postal_domicilio",
                ciudad_domicilio: "ciudad_domicilio",
                municipio_domicilio: "municipio_domicilio",
                estado_domicilio: "estado_domicilio",
                pais_domicilio: "pais_domicilio",
                notas_domicilio: "notas_domicilio"
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                //agente
                rfc_cliente: "[RFC del Cliente - Obligatorio]",
                nombre: "[Nombre del Agente - Obligatorio]",
                rfc: "[RFC del Agente - Obligatorio]",
                patente: "[Patente - Obligatorio]",
                rfc_sociedad: "[RFC Servicios Aduanales - Obligatorio]",
                telefono: "[Opcional]",
                agencia_aduanal: "[Nombre de Servicios Aduanales - Obligatorio]",
                metadato: "[Metadato - Obligatorio]",
                calle: "[Opcional]",
                numero_exterior: "[Opcional]",
                numero_interior: "[Opcional]",
                colonia: "[Opcional]",
                codigo_postal: "[Opcional]",
                ciudad: "[Nombre de la ciudad - Opcional]",
                municipio: "[Nombre del municipio - Opcional]",
                estado: "[Nombre del estado - Opcional]",
                pais: "[Clave del país - Opcional]",
                banco: "[Opcional]",
                sucursal: "[Opcional]",
                cuenta: "[Opcional]",
                clabe: "[Opcional]",
                swift: "[Opcional]",
                aba: "[Opcional]",
                banco_interamericano: "[Opcional]",
                beneficiario: "[Opcional]",
                referencia_banco: "[Referencia del banco - Opcional]",
                //contactos
                aduana_contacto: "[Clave de Aduana - Opcional]",
                nombre_contacto: "[Nombre de Contacto - Opcional]",
                email_contacto: "[Email de Contacto - Opcional]",
                telefono_contacto: "[Teléfono del Contacto - Opcional]",
                movil_contacto: "[Móvil del Contacto - Opcional]",
                //domicilios
                aduana_domicilio: "[Clave de Aduana - Opcional]",
                calle_domicilio: "[Opcional]",
                numero_exterior_domicilio: "[Opcional]",
                numero_interior_domicilio: "[Opcional]",
                colonia_domicilio: "[Opcional]",
                codigo_postal_domicilio: "[Opcional]",
                ciudad_domicilio: "[Nombre de la ciudad - Opcional]",
                municipio_domicilio: "[Nombre del municipio - Opcional]",
                estado_domicilio: "[Nombre del estado - Opcional]",
                pais_domicilio: "[Clave del país - Opcional]",
                notas_domicilio: "[Opcional]"
            }]
        },
        //DOMICILIOS
        modelDomicilio: {
            agente: "",
            aduana: "",
            calle: "",
            numero_exterior: "",
            numero_interior: "",
            colonia: "",
            codigo_postal: "",
            ciudad: "",
            municipio: "",
            estado: "",
            estado_nombre: "",
            pais: "",
            notas: ""
        },
        domicilios: {
            items: []
        },
        columnsDomicilios: [
            "aduana_nombre",
            "calle",
            "numero_exterior",
            "municipio",
            "estado_nombre",
            "pais_nombre",
            "notas",
            "actions"
        ],
        optionsDomicilios: {
            filterable: [
                "aduana_nombre",
                "calle",
                "numero_exterior",
                "municipio",
                "estado_nombre",
                "pais_nombre",
                "notas"
            ],
            sortable: [
                "aduana_nombre",
                "calle",
                "numero_exterior",
                "municipio",
                "estado_nombre",
                "pais_nombre",
                "notas"
            ],
            headings: {
                aduana_nombre: "Aduana",
                calle: "Calle",
                numero_exterior: "No. Exterior",
                numero_interior: "No. Interior",
                colonia: "Colonia",
                codigo_postal: "CP",
                ciudad: "Ciudad",
                municipio: "Municipio",
                estado_nombre: "Estado",
                pais_nombre: "País",
                notas: "Notas",
                actions: "Operaciones"
            }
        },
        //CONTACTOS
        modelContacto: {
            id_contacto_agente_aduanal: "",
            agente_aduanal: "",
            aduana: "",
            nombre: "",
            email: "",
            telefono: "",
            movil: ""
        },
        contactos: {
            items: []
        },
        columnsContactos: [
            "aduana_nombre",
            "nombre",
            "email",
            "telefono",
            "movil",
            "actions"
        ],
        optionsContactos: {
            filterable: ["aduana_nombre", "nombre", "email", "telefono", "movil"],
            sortable: ["aduana_nombre", "nombre", "email", "telefono", "movil"],

            headings: {
                aduana: "Aduana",
                nombre: "Nombre Contacto",
                email: "Email",
                telefono: "Telefono",
                movil: "Móvil",
                actions: "Operaciones"
            }
        },
        agente_seleccionado: "",
        agente_seleccionado_metadato: "",
        camposObligatorios: {
            "rfc_cliente": "RFC del cliente",
            "nombre": "Nombre del agente",
            "rfc": "RFC del agente",
            "patente": "Patente",
            "rfc_sociedad": "RFC Sociedad",            
            "agencia_aduanal": "Agencia Aduanal",
            "metadato": "Metadato"            
        },
    }),
    computed: {
        datafiltered() {
            if (this.$refs.principalTable != null) {
                return this.$refs.principalTable.allFilteredData;
            } else {
                return this.agentes.items;
            }
        }
    },
    methods: {
        nombreAduanaSelect: function (aduana) {
            return aduana.clave + " - " + aduana.nombre;
        },
        reload2() {
            var myIFrame = document.getElementById("myIframe2");
            myIFrame.src = "";
            myIFrame.src = "https://aplicacionesc.mat.sat.gob.mx/SOIANET/oia_wfrPatConsulRFC.aspx";
            var frameDocument = myIFrame.contentDocument ? myIFrame.contentDocument : myIFrame.contentWindow.document;

        },
        showDetail: function (row) {
            if (this.agente_seleccionado != row.id_agente_aduanual) {
                this.agente_seleccionado = row.id_agente_aduanual;
                this.agente_seleccionado_metadato = row.metadato;
                this.cargarDomicilios();
                this.cargarContactos();
                var detallesAbiertos = this.$refs.principalTable.openChildRows;
                for (var k in detallesAbiertos) {
                    //Cerramos detalles abiertos
                    if (detallesAbiertos[k] != row.id_agente_aduanual)
                        this.$refs.principalTable.toggleChildRow(detallesAbiertos[k]);
                }
            } else {
                //Significa que dio clic en '-' solo cerramos el detalle y no hacemos nada
                this.agente_seleccionado = "";
                this.agente_seleccionado_metadato = "";
            }
            this.$refs.principalTable.toggleChildRow(row.id_agente_aduanual); //Mostramos detalle seleccionado
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Agente Aduanal";
                this.update = false;
            } else {
                this.title = "Actualizar Agente Aduanal";
                this.update = true;
            }
            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente", "");
        },

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_agente_aduanual + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();                        
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();                        
                        this.modal = false;
                    });
            }
        },
        cargarContactosDomicilios: function (argument) {
            this.items_domicilios = [];
            this.items_contactos = [];

            for (var i = 0; i < this.agentes.items.length; i++) {
                var datos = {
                    agente_aduanal: this.agentes.items[i].id_agente_aduanual
                };

                // Cargar domicilios
                axios
                    .post(this.URL + "domicilios/c/list_all/", datos)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            let items = res.data;

                            for (var k in items) {
                                items[k].pais_nombre = this.obtenerPais(items[k].pais);                                
                                items[k].aduana_nombre = this.obtenerAduana(items[k].aduana);
                                items[k].agente = this.obtenerAgente(items[k].agente_aduanal);
                            }

                            this.items_domicilios = this.items_domicilios.concat(items);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });

                // Cargar Contactos
                axios
                    .post(this.URL + "contactos/c/list_all/", datos)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            let items = res.data;

                            for (var k in items) {
                                items[k].aduana_nombre = this.obtenerAduana(items[k].aduana);
                                items[k].agente = this.obtenerAgente(items[k].agente_aduanal);
                            }

                            this.items_contactos = this.items_contactos.concat(items);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
        },
        cargar: function () {
            var datos = {
                cliente: this.$local_storage.get("id_cliente", ""),
                rfc_agencia: this.rfc_agencia
            };
            axios
                .post(this.URL + "get_agentes/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.agentes.items = res.data;
                        for (var k in this.agentes.items) {
                            this.agentes.items[k].pais_nombre = this.obtenerPais(
                                this.agentes.items[k].pais
                            );
                            this.agentes.items[k].rfc_cliente = this.get_rfc_by_cliente_id(
                                this.agentes.items[k].cliente
                            );                            
                        }

                        this.cargarContactosDomicilios();
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {

                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarAduanas: function () {
            axios
                .get(this.$hostname + "catalogos/aduanas/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.aduanas = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de aduanas",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de aduanas.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;                    
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.delete(this.URL + id_registro + "/")
                        .then(response => {
                            this.agente_seleccionado = "";
                            this.agente_seleccionado_metadato = "";
                            this.cargar();
                            this.domicilios.items = [];
                            this.contactos.items = [];
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                            this.$root.$dialogLoader.hide();
                        });
                }                    
            });
        }, //delete

        openModalOtro: function (modalTipo, type) {
            if (type === 1) this.limpiarModelos();
            if (modalTipo == "domicilio") this.modalDomicilio = true;
            else this.modalContacto = true;
        },
        limpiarModelos: function () {
            for (var k in this.modelDomicilio) {
                this.modelDomicilio[k] = "";
            }
            this.modelDomicilio.agente_aduanal = this.agente_seleccionado;
            for (var k in this.modelContacto) {
                this.modelContacto[k] = "";
            }
            this.modelContacto.agente_aduanal = this.agente_seleccionado;
        },
        

        guardarDomicilio: function () {
            const datos = this.modelDomicilio;

            if (!this.$refs.formDomicilio.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL + "domicilios/c/";
                if (this.modelDomicilio.id_domicilio_agente_aduanal > 0) {
                    metodo = "put";
                    urlCliente += this.modelDomicilio.id_domicilio_agente_aduanal + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                    })
                    .then(() => {
                        this.cargarDomicilios();
                        this.$root.$dialogLoader.hide();
                        this.modalDomicilio = false;
                    });
            }
        },

        cargarDomicilios: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                agente_aduanal: this.agente_seleccionado
            };
            axios
                .post(this.URL + "domicilios/c/list_all/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.domicilios.items = res.data;
                        for (var k in this.domicilios.items) {
                            this.domicilios.items[k].pais_nombre = this.obtenerPais(
                                this.domicilios.items[k].pais
                            );                            
                            this.domicilios.items[k].aduana_nombre = this.obtenerAduana(
                                this.domicilios.items[k].aduana
                            );
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los domicilios.",
                        footer: ""
                    });
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getRegistroDomicilio: function (id_domicilio) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + "domicilios/c/" + id_domicilio + "/")
                .then(response => {
                    this.modelDomicilio = response.data;                    
                    this.openModalOtro("domicilio", 2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },

        deleteRegistroDomicilio: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                        .delete(this.URL + "domicilios/c/" + id_registro + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.cargarDomicilios();
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete
        obtenerPais(id_pais) {
            let paises = this.paises.filter(function (e) {
                return e.id_pais == id_pais;
            });
            return paises.length > 0 ? paises[0].nombre : "N/A";
        },
        obtenerAduana(id_aduana) {
            let aduanas = this.aduanas.filter(function (e) {
                return e.id_aduana == id_aduana;
            });
            return aduanas.length > 0 ?
                aduanas[0].clave + " - " + aduanas[0].nombre :
                "N/A";
        },
        obtenerAgente(id_agente) {
            let agentes = this.agentes.items.filter(function (e) {
                return e.id_agente_aduanual == id_agente;
            });
            return agentes.length > 0 ?
                agentes[0].patente + " - " + agentes[0].nombre :
                "N/A";
        },
        verificaAduana: function (aduana, opcion) {
            if (aduana == undefined) return false;

            var search = this.aduanas.filter(function (e) {
                return parseInt(e.clave.trim()) == parseInt(aduana.toString().trim());
            });
            if (opcion == "id") return search.length > 0 ? search[0].clave : "";
            else return search.length > 0;
        },
        uniqueAduanaDomicilio: function (modelDomicilio) {
            var search = this.domicilios.items.filter(function (e) {
                return (
                    e.aduana == modelDomicilio.aduana &&
                    e.id_domicilio_agente_aduanal !=
                    modelDomicilio.id_domicilio_agente_aduanal
                );
            });
            return search.length > 0 ?
                "La aduana ya se registró en otro domicilio." :
                true;
        },
        uniqueAduanaContacto: function (modelContacto) {
            var search = this.contactos.items.filter(function (e) {
                return (
                    e.aduana == modelContacto.aduana &&
                    e.id_contacto_agente_aduanal !=
                    modelContacto.id_contacto_agente_aduanal
                );
            });
            return search.length > 0 ?
                "La aduana ya se registró en otro contacto." :
                true;
        },
        verificaComboPaises: async function (clave_pais) {
            var erroresText = "";
            let verificaP = await this.verificaPais(clave_pais, "");
            if (verificaP == 0) {
                erroresText +=
                    '- La clave país "' + clave_pais + '" no existe en el sistema.<br>';
            }
            return erroresText;
        },
        verificaPais: function (clave_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_pais == undefined) resolve(0);

                var search = thisObject.paises.filter(function (e) {
                    return (
                        e.clave_m3
                        .toString()
                        .trim()
                        .toLowerCase() ==
                        clave_pais
                        .toString()
                        .trim()
                        .toLowerCase()
                    );
                });
                if (opcion == "id") resolve(search.length > 0 ? search[0].id_pais : "");
                else resolve(search.length);
            });
        },
        
        guardarContacto: function () {
            const datos = this.modelContacto;

            if (!this.$refs.formContacto.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL + "contactos/c/";
                if (this.modelContacto.id_contacto_agente_aduanal > 0) {
                    metodo = "put";
                    urlCliente += this.modelContacto.id_contacto_agente_aduanal + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                    })
                    .then(() => {
                        this.cargarContactos();
                        this.$root.$dialogLoader.hide();
                        this.modalContacto = false;
                    });
            }
        },

        cargarContactos: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            var datos = {
                agente_aduanal: this.agente_seleccionado
            };
            axios
                .post(this.URL + "contactos/c/list_all/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.contactos.items = res.data;
                        for (var k in this.contactos.items) {
                            this.contactos.items[k].aduana_nombre = this.obtenerAduana(
                                this.contactos.items[k].aduana
                            );
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los contactos.",
                        footer: ""
                    });
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getRegistroContacto: function (id_registro) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + "contactos/c/" + id_registro + "/")
                .then(response => {
                    this.modelContacto = response.data;
                    this.openModalOtro("contacto", 2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },

        deleteRegistroContacto: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                        .delete(this.URL + "contactos/c/" + id_registro + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        })
                        .then(() => {
                            this.cargarContactos();
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        }, //delete

        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = "";
            var aduanasContactoRfc = [];
            var aduanasDomicilioRfc = [];
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 100){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 500, favor de verificar.";
                } else {

                    for (var k in results) {
                        renglonesLeidos++;
                        results[k]["user_updated"] = thisObject.$local_storage.get("email");
                        
                        var obligatorios = thisObject.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            //Si es agencia, asignar el cliente correspondiente de acuerdo a la columna rfc_cliente            
                            if (thisObject.rfc_agencia!="" && results[k]["rfc_cliente"]){
                                 var cliente_id = thisObject.get_cliente_id_by_rfc(results[k]["rfc_cliente"]);
                                 if(cliente_id == null){
                                    errores++;
                                    erroresText += "- El RFC del cliente \"" + results[k]["rfc_cliente"] + "\" no existe en el sistema.<br>";
                                 } else {
                                    results[k]["cliente"] = cliente_id;
                                 }                                 
                            } else {
                                results[k]["cliente"] = thisObject.$local_storage.get("id_cliente");
                            }

                            if (results[k]["rfc"] == undefined) {
                                errores++;
                                erroresText +=
                                    "- En cada renglón se debe especificar el agente, sin importar que se repita. Para contactos y domicilios no se pueden repetir las aduanas para el mismo agente.\n";
                            } else {
                                if (aduanasContactoRfc[results[k]["rfc"]] == undefined)
                                    aduanasContactoRfc[results[k]["rfc"]] = [];
                                if (aduanasDomicilioRfc[results[k]["rfc"]] == undefined)
                                    aduanasDomicilioRfc[results[k]["rfc"]] = [];

                                if (
                                    results[k]["aduana_contacto"] != undefined &&
                                    !thisObject.verificaAduana(results[k]["aduana_contacto"])
                                ) {
                                    errores++;
                                    erroresText +=
                                        '- La aduana de contacto "' +
                                        results[k]["aduana_contacto"] +
                                        '" no existe en el sistema. Verifique también que la celda sea tipo texto.<br>';
                                } else if (results[k]["aduana_contacto"] != undefined) {
                                    // let pos = aduanasContactoRfc[results[k]["rfc"]].indexOf(results[k]["aduana_contacto"]);
                                    // if (pos != -1) {
                                    //     errores++;
                                    //     erroresText+= "- La aduana \""+results[k]["aduana_contacto"]+"\" no debe repetirse para los contactos del agente \""+results[k]["rfc"]+"\".<br>";
                                    // } else {
                                    // }
                                    aduanasContactoRfc[results[k]["rfc"]].push(
                                        results[k]["aduana_contacto"]
                                    );
                                }

                                if (
                                    results[k]["aduana_domicilio"] != undefined &&
                                    !thisObject.verificaAduana(results[k]["aduana_domicilio"])
                                ) {
                                    errores++;
                                    erroresText +=
                                        '- La aduana de domicilio "' +
                                        results[k]["aduana_domicilio"] +
                                        '" no existe en el sistema. Verifique también que la celda sea tipo texto.<br>';
                                } else if (results[k]["aduana_domicilio"] != undefined) {
                                    let pos = aduanasDomicilioRfc[results[k]["rfc"]].indexOf(
                                        results[k]["aduana_domicilio"]
                                    );
                                    if (pos != -1) {
                                        errores++;
                                        erroresText +=
                                            '- La aduana "' +
                                            results[k]["aduana_domicilio"] +
                                            '" no debe repetirse para los domicilios del agente "' +
                                            results[k]["rfc"] +
                                            '".<br>';
                                    } else {
                                        aduanasDomicilioRfc[results[k]["rfc"]].push(
                                            results[k]["aduana_domicilio"]
                                        );
                                    }
                                }

                                if (results[k]["pais"] != undefined) {
                                    let verificaAgentePaises = await thisObject.verificaComboPaises(results[k]["pais"]);
                                    if (verificaAgentePaises.toString().trim().length > 0) {
                                        errores++;
                                        if (erroresText.indexOf(verificaAgentePaises) == -1)
                                            erroresText += verificaAgentePaises;
                                    }
                                }
                                

                                if (results[k]["pais_domicilio"] != undefined) {
                                    let verificaDomicilioPaises = await thisObject.verificaComboPaises(results[k]["pais_domicilio"]);
                                    if (verificaDomicilioPaises.toString().trim().length > 0) {
                                        errores++;
                                        if (erroresText.indexOf(verificaDomicilioPaises) == -1)
                                            erroresText += verificaDomicilioPaises;
                                    }
                                }
                                
                            }
                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }
                }

                return {
                    errores: errores,
                    erroresText: erroresText
                };
            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
            }
            //}); //promise
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = "";
            var aduanasContactoRfc = [];
            var aduanasDomicilioRfc = [];
            this.importData = [];
            try {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    for (var k in results) {
                        if (this.importData[results[k]["rfc"]] == undefined)
                            this.importData[results[k]["rfc"]] = {};
                        if (this.importData[results[k]["rfc"]]["contactos"] == undefined)
                            this.importData[results[k]["rfc"]]["contactos"] = [];
                        if (this.importData[results[k]["rfc"]]["domicilios"] == undefined)
                            this.importData[results[k]["rfc"]]["domicilios"] = [];

                        var id_pais =
                            results[k]["pais"] != undefined ?
                            await this.verificaPais(results[k]["pais"], "id") :
                            "";
                        
                        this.importData[results[k]["rfc"]]["agente"] = {
                            nombre: results[k]["nombre"],
                            rfc: results[k]["rfc"],
                            patente: results[k]["patente"],
                            aduanas_operacion: results[k]["rfc_sociedad"],
                            telefono: results[k]["telefono"],
                            agencia_aduanal: results[k]["agencia_aduanal"],
                            metadato: results[k]["metadato"],
                            calle: results[k]["calle"],
                            numero_exterior: results[k]["numero_exterior"],
                            numero_interior: results[k]["numero_interior"],
                            colonia: results[k]["colonia"],
                            codigo_postal: results[k]["codigo_postal"],
                            ciudad: results[k]["ciudad"],
                            municipio: results[k]["municipio"],
                            estado_nombre: results[k]["estado"],
                            pais: id_pais,
                            banco: results[k]["banco"],
                            sucursal: results[k]["sucursal"],
                            cuenta: results[k]["cuenta"],
                            clabe: results[k]["clabe"],
                            swift: results[k]["swift"],
                            aba: results[k]["aba"],
                            banco_interamericano: results[k]["banco_interamericano"],
                            beneficiario: results[k]["beneficiario"],
                            referencia_banco: results[k]["referencia_banco"],
                            cliente: results[k]["cliente"],
                            user_updated: results[k]["user_updated"]
                        };

                        results[k]["aduana_contacto"] = this.verificaAduana(
                            results[k]["aduana_contacto"],
                            "id"
                        );
                        if (
                            results[k]["aduana_contacto"] != undefined &&
                            results[k]["aduana_contacto"] != false
                        )
                            this.importData[results[k]["rfc"]]["contactos"].push({
                                aduana: results[k]["aduana_contacto"],
                                nombre: results[k]["nombre_contacto"],
                                email: results[k]["email_contacto"],
                                telefono: results[k]["telefono_contacto"],
                                movil: results[k]["movil_contacto"]
                            });

                        var id_pais_domicilio =
                            results[k]["pais_domicilio"] != undefined ?
                            await this.verificaPais(results[k]["pais_domicilio"], "id") :
                            "";
                        
                        results[k]["aduana_domicilio"] = this.verificaAduana(
                            results[k]["aduana_domicilio"],
                            "id"
                        );
                        if (
                            results[k]["aduana_domicilio"] != undefined &&
                            results[k]["aduana_domicilio"] != false
                        )
                            this.importData[results[k]["rfc"]]["domicilios"].push({
                                aduana: results[k]["aduana_domicilio"],
                                calle: results[k]["calle_domicilio"],
                                numero_exterior: results[k]["numero_exterior_domicilio"],
                                numero_interior: results[k]["numero_interior_domicilio"],
                                colonia: results[k]["colonia_domicilio"],
                                codigo_postal: results[k]["codigo_postal_domicilio"],
                                ciudad: results[k]["ciudad_domicilio"],
                                municipio: results[k]["municipio_domicilio"],
                                estado_nombre: results[k]["estado_domicilio"],
                                pais: id_pais_domicilio,
                                notas: results[k]["notas_domicilio"]
                            });
                    }

                    var resultadoFinal = [];
                    for (var k in this.importData) {
                        resultadoFinal.push(this.importData[k]);
                    }

                    axios
                        .post(this.URL + "importar_agentes/", resultadoFinal)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];
                                            if (key != "contactos" && key != "domicilios") {
                                                //Este trae 2 niveles, por eso el campo queda en la key2
                                                Object.keys(errors).forEach(function (key2) {
                                                    let pos = errores.indexOf(key + ": " + errors[key2]);
                                                    if (pos < 0) {
                                                        errores += key + ": " + errors[key2];
                                                        errores += "<br>";
                                                    }
                                                });
                                            } else {
                                                //contactos y domicilios, traen 3 niveles, por eso el campo queda en la key3
                                                Object.keys(errors).forEach(function (key2) {
                                                    Object.keys(errors[key2]).forEach(function (key3) {
                                                        let pos = errores.indexOf(
                                                            key3 + ": " + errors[key2][key3]
                                                        );
                                                        if (pos < 0) {
                                                            errores += key3 + ": " + errors[key2][key3];
                                                            errores += "<br>";
                                                        }
                                                    });
                                                });
                                            }
                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();                            
                        });
                }
            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
                this.$root.$dialogLoader.hide();
            }
        },
        selectComboPais(id) {
            this.model.pais = id;
        },
        selectComboPaisDomicilio(id) {
            this.modelDomicilio.pais = id;
        },        
        cargarRfcsAgencia: function(){
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let data = {
                rfc_grupo: this.rfc_agencia,
            };
            axios.post(this.$hostname+ "grupos/get_clientes_grupo_by_rfc/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientes_agencia = res.data;
                    }
                    this.cargar();
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes del Grupo. Comúniquese con Soporte.",
                        footer: ""
                    });
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },
        getNombreCliente: function (record) {
            return record.rfc + " - " + record.razon_social;
        },
        get_rfc_by_cliente_id: function(cliente_id){
            var cliente = this.clientes_agencia.find(x => x.id_cliente == cliente_id)
            if(cliente){
                return cliente.rfc;
            }
            return null;
        },
        get_cliente_id_by_rfc: function(rfc){
            var cliente = this.clientes_agencia.find(x => x.rfc == rfc)
            if(cliente){
                return cliente.id_cliente;
            }
            return null;
        },
    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/agentes_aduanales/";        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        this.cargarPaises();        
        this.cargarAduanas();

        this.rfc_agencia = this.$local_storage.get("rfc_agencia","");
        if(this.rfc_agencia == ""){
            this.cargar();
            //Se quita columna de rfc de clientes
            this.columns = this.columns.filter(c => c != "rfc_cliente");            
            delete this.camposObligatorios.rfc_cliente;
            delete this.agentes.encabezadoLayout.rfc_cliente;
            delete this.agentes.camposLayout[0].rfc_cliente;
            delete this.agentes.camposexcel["RFC Cliente"];
        } else {
            this.cargarRfcsAgencia();
        }        

    }
};
</script>

<style scoped>
#agentes>>>.VueTables__child-row-toggler {
    display: none;
}
</style>



<style scoped>
.iframe-container {

    padding-top: 56.25%;
    position: relative;
    overflow: hidden;
}

.iframe-container iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
    padding-left: 20px;
    padding-right: 20px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>